import {
    IEngineeringAuditBarrierReport,
    IEngineeringAuditConsequenceReport,
    IEngineeringAuditControlBarrierReport,
    IEngineeringAuditEscalationFactorReport,
    IEngineeringAuditThreatReport,
    IEngineeringAuditTopEventReport
} from 'plugin-codaf-risk-ext-bowtie/types/engineeringAudit'
import { BOWTIE_BASE_URL, ENGINEERING_AUDIT_ENDPOINTS } from 'plugin-codaf-risk-ext-bowtie/utils/constants'

export interface ITimeFilter {
    startDay: string
    startHour: string
    endDay: string
    endHour: string
    perPage?: number
    page?: number
    sortOrder?: string
    sortBy?: string
    limit?: string
    quickSearch?: string
}

export interface IEngineeringAuditReportRequest extends ITimeFilter {
    filterByResource?: string[]
    filterByBowtieName?: string[]
}

export const getEngineeringAuditConsequence = async (
    id: number,
    params?: IEngineeringAuditReportRequest
): Promise<IEngineeringAuditConsequenceReport> => {
    const qs = new URLSearchParams({
        limit: params?.limit.toString() ?? '30',
        offset: ((params?.page ?? 1) - 1).toString() ?? '',
        startDay: params?.startDay?.toString() ?? '',
        startHour: params.startHour ?? '',
        endDay: params?.endDay ?? '',
        endHour: params?.endHour ?? '',
        sortOrder: params.sortOrder ?? '',
        sortBy: params.sortBy ?? '',
        quickSearch: params?.quickSearch ?? ''
    }).toString()

    return fetch(`${BOWTIE_BASE_URL}/engineeringaudit/${id}/${ENGINEERING_AUDIT_ENDPOINTS.consequence}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
        // body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const getEngineeringAuditThreat = async (
    id: number,
    params?: IEngineeringAuditReportRequest
): Promise<IEngineeringAuditThreatReport> => {
    const qs = new URLSearchParams({
        limit: params?.limit.toString() ?? '30',
        offset: ((params?.page ?? 1) - 1).toString() ?? '',
        startDay: params?.startDay?.toString() ?? '',
        startHour: params.startHour ?? '',
        endDay: params?.endDay ?? '',
        endHour: params?.endHour ?? '',
        sortOrder: params.sortOrder ?? '',
        sortBy: params.sortBy ?? '',
        quickSearch: params?.quickSearch ?? ''
    }).toString()

    return fetch(`${BOWTIE_BASE_URL}/engineeringaudit/${id}/${ENGINEERING_AUDIT_ENDPOINTS.threat}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
        // body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const getEngineeringAuditTopEvent = async (
    id: number,
    params?: IEngineeringAuditReportRequest
): Promise<IEngineeringAuditTopEventReport> => {
    const qs = new URLSearchParams({
        limit: params?.limit.toString() ?? '30',
        offset: ((params?.page ?? 1) - 1).toString() ?? '',
        startDay: params?.startDay?.toString() ?? '',
        startHour: params.startHour ?? '',
        endDay: params?.endDay ?? '',
        endHour: params?.endHour ?? '',
        sortOrder: params.sortOrder ?? '',
        sortBy: params.sortBy ?? '',
        quickSearch: params?.quickSearch ?? ''
    }).toString()

    return fetch(`${BOWTIE_BASE_URL}/engineeringaudit/${id}/${ENGINEERING_AUDIT_ENDPOINTS.topEvent}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
        // body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const getEngineeringAuditBarrier = async (
    id: number,
    params?: IEngineeringAuditReportRequest
): Promise<IEngineeringAuditBarrierReport> => {
    const qs = new URLSearchParams({
        limit: params?.limit.toString() ?? '30',
        offset: ((params?.page ?? 1) - 1).toString() ?? '',
        startDay: params?.startDay?.toString() ?? '',
        startHour: params.startHour ?? '',
        endDay: params?.endDay ?? '',
        endHour: params?.endHour ?? '',
        sortOrder: params.sortOrder ?? '',
        sortBy: params.sortBy ?? '',
        quickSearch: params?.quickSearch ?? ''
    }).toString()

    return fetch(`${BOWTIE_BASE_URL}/engineeringaudit/${id}/${ENGINEERING_AUDIT_ENDPOINTS.barrier}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
        // body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const getEngineeringAuditEscalationFactor = async (
    id: number,
    params?: IEngineeringAuditReportRequest
): Promise<IEngineeringAuditEscalationFactorReport> => {
    const qs = new URLSearchParams({
        limit: params?.limit.toString() ?? '30',
        offset: ((params?.page ?? 1) - 1).toString() ?? '',
        startDay: params?.startDay?.toString() ?? '',
        startHour: params.startHour ?? '',
        endDay: params?.endDay ?? '',
        endHour: params?.endHour ?? '',
        sortOrder: params.sortOrder ?? '',
        sortBy: params.sortBy ?? '',
        quickSearch: params?.quickSearch ?? ''
        // filterByResource: params.filterByResource ? params.filterByResource.toString() : '',
        // filterByBowtieName: params.filterByBowtieName ? params.filterByBowtieName.toString() : ''
    }).toString()

    return fetch(`${BOWTIE_BASE_URL}/engineeringaudit/${id}/${ENGINEERING_AUDIT_ENDPOINTS.escalationFactor}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
        // body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const getEngineeringAuditControlBarrier = async (
    id: number,
    params?: IEngineeringAuditReportRequest
): Promise<IEngineeringAuditControlBarrierReport> => {
    const qs = new URLSearchParams({
        limit: params?.limit.toString() ?? '30',
        offset: ((params?.page ?? 1) - 1).toString() ?? '',
        startDay: params?.startDay?.toString() ?? '',
        startHour: params.startHour ?? '',
        endDay: params?.endDay ?? '',
        endHour: params?.endHour ?? '',
        sortOrder: params.sortOrder ?? '',
        sortBy: params.sortBy ?? '',
        quickSearch: params?.quickSearch ?? ''
        // filterByResource: params.filterByResource ? params.filterByResource.toString() : '',
        // filterByBowtieName: params.filterByBowtieName ? params.filterByBowtieName.toString() : ''
    }).toString()

    return fetch(`${BOWTIE_BASE_URL}/engineeringaudit/${id}/${ENGINEERING_AUDIT_ENDPOINTS.controlBarrier}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
        // body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}
